/// <reference path="../../typings/browser.d.ts" />

namespace Application.Services {
    'use strict';

    import HalConverter = Models.HalConverter;

    export class MVPServerInfoService {
        public static $name: string = "mvpServerInfoService";
        public static $inject: string[] = ['backendService'];

        private backendService: Services.BackendService;

        private backendBaseUrl: string = window.backendUrl;
        private serviceUrl: string = this.backendBaseUrl + 'mvpadapter/serverinfo/';

        constructor(backendService: Services.BackendService) {
            this.backendService = backendService;
        }

        public getServerClientsInfo(serverHref: string): ng.IPromise<Models.ServerClientsInfo> {
            return this.backendService.get(this.serviceUrl + serverHref + '/clients')
            .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<Models.ServerClientsInfo>>) => {
                 return HalConverter.convertElement(result.data, Models.ServerClientsInfo.createEmpty);
            });
        }
    }
}